// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutHeaderPhoneStyles } from "@guestsupply/App/Components/Checkout/CheckoutHeaderPhone";
import HeaderPhone from "@guestsupply/XDL/Icons/HeaderPhone";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

checkoutHeaderPhoneStyles.link = {
    ...createLinkIconStyles(HeaderPhone, {
        color: "text.main",
        typographyProps: {
            css: css`
                display: flex;
                align-items: center;
                gap: 8px;
            `,
        },
        icon: {
            iconProps: {
                size: 26,
                color: "text.main",
                css: css`
                    opacity: 1;
                `,
            },
            position: "left",
        },
    }),
};
